import { Accordion } from './Accordion';
import { Badge } from './Badge';
import { Button } from './Button';
import { Checkbox } from './Checkbox';
import { Input } from './Input';
import { Menu } from './Menu';
import { Modal } from './Modal';
import { Popover } from './Popover';
import { Radio } from './Radio';
import { Select } from './Select';
import { Skeleton } from './Skeleton';
import { Spinner } from './Spinner';
import { Switch } from './Switch';
import { Tooltip } from './Tooltip';

export const components = {
  Accordion,
  Badge,
  Button,
  Menu,
  Checkbox,
  Modal,
  Input,
  Select,
  Radio,
  Popover,
  Spinner,
  Switch,
  Skeleton,
  Tooltip,
  NumberInput: Input,
};
